	import Vue from 'vue'
	import Router from 'vue-router'
	// import axios from '../api/http'
	import wx from 'weixin-js-sdk'
	import { baseApiModules } from '@/api'
	import util from '../util/util'

	Vue.use(Router)

	const lessonList = resolve => require(['@/views/lesson/lessonList'], resolve);
	const about = resolve => require(['@/views/about/about'], resolve);
	const myOrder = resolve => require(['@/views/about/myOrder'], resolve);
	const myCourse = resolve => require(['@/views/about/myCourse'], resolve);
	const myMedal = resolve => require(['@/views/about/myMedal'], resolve);
	const customerService = resolve => require(['@/views/about/customerService'], resolve);
	const cooperation = resolve => require(['@/views/about/cooperation'], resolve);
	const activityList = resolve => require(['@/views/vocation/activityList'], resolve);
	const activityDetail = resolve => require(['@/views/vocation/activityDetail'], resolve);
	const paySuccess = resolve => require(['@/views/payment/paySuccess'], resolve);
	const subLessonList = resolve => require(['@/views/lesson/subLessonList'], resolve);
	const purchaseLesson = resolve => require(['@/views/lesson/purchaseLesson'], resolve);
	const subLessonDetail = resolve => require(['@/views/lesson/subLessonDetail'], resolve);
	const topic = resolve => require(['@/views/raffle/topic'], resolve);
	// const gifts = resolve => require(['@/views/raffle/gifts'], resolve);
	const pay = resolve => require(['@/views/payment/pay'], resolve);
	const poster = resolve => require(['@/views/lesson/poster'], resolve);
	const couponList = resolve => require(['@/views/coupon/couponList'], resolve);
	const detailSchedule = resolve => require(['@/views/userShare/detailSchedule'], resolve);
	const myWallet = resolve => require(['@/views/about/myWallet'], resolve);
	const loginPhone = resolve => require(['@/views/login/login'], resolve);

	const liveList = resolve => require(['@/views/liveBroadcast/liveList'], resolve);
	const liveBroadcast = resolve => require(['@/views/liveBroadcast/liveBroadcast'], resolve);
	const playAgin = resolve => require(['@/views/liveBroadcast/playAgin'], resolve);
	const deliveryAddress = resolve => require(['@/views/payment/deliveryAddress'],resolve);
	const exhibitionHall = resolve => require(['@/views/guide/exhibitionHall'],resolve);
	const exhibits = resolve => require(['@/views/guide/exhibits'],resolve);
	const guideDetails = resolve => require(['@/views/guide/guideDetails'],resolve);
	const myGuide = resolve => require(['@/views/about/myGuide'],resolve);
	const router = new Router({
	routes: [
		{
		path: '/',
		name: '首页',
		component: lessonList
		},
		{
		path: '/about/about',
		name: '我的',
		component: about
		},
		{
		path: '/vocation/activityList',
		name: '假日出发',
		component: activityList
		},
		{
		path: '/about/myOrder',
		name: '我的订单',
		component: myOrder
		},
		{
		path: '/about/myCourse',
		name: '我的课程',
		component: myCourse
		},
		{
		path: '/about/myMedal',
		name: '我的口袋',
		component: myMedal
		},
		{
		path: '/about/customerService',
		name: '客服咨询',
		component: customerService
		},
		{
		path: '/about/cooperation',
		name: '商务合作',
		component: cooperation
		},
		{
		path: '/vocation/activityDetail',
		name: '活动详情',
		component: activityDetail
		},
		{
		path: '/payment/paySuccess',
		name: '支付成功',
		component: paySuccess
		},
		{
		path: '/lesson/subLessonList',
		name: '子课程列表',
		component: subLessonList
		},
		{
		path: '/lesson/subLessonDetail',
		name: '子课程详情',
		component: subLessonDetail
		},
		{
		path: '/lesson/purchaseLesson',
		name: '课程购买',
		component: purchaseLesson
		},
		{
		path: '/raffle/topic',
		name: '抽奖答题',
		component: topic
		},
		// {
		//   path: '/raffle/gifts',
		//   name: '领取礼物',
		//   component: gifts
		// },
		{
		path: '/payment/pay',
		name: '领取礼物',
		component: pay
		},
		{
		path: '/lesson/poster',
		name: '分享海报',
		component: poster
		},
		{
		path: '/coupon/couponList',
		name: '优惠券列表',
		component: couponList
		},
		{
		path: '/usershare/detailschedule',
		name: '收支明细',
		component: detailSchedule
		},
		{
		path: '/about/mywallet',
		name: '我的钱包',
		component: myWallet
		},
		{
		path: '/login/login',
		name: 'phone注册',
		component: loginPhone
		},
		{
		path: '/liveBroadcast/liveList',
		name: '直播列表',
		component: liveList
		},
		{
		path: '/liveBroadcast/playAgin',
		name: '回放',
		component: playAgin
		},
		{
		path: '/liveBroadcast/liveBroadcast',
		name: '直播',
		component: liveBroadcast
		},
		{
		path: '/payment/deliveryAddress',
		name: '物流',
		component: deliveryAddress
		}
		,
		{
		path: '/guide/guideDetails',
		name: '博物馆',
		component: guideDetails
		},
		{
		path: '/guide/exhibitionHall',
		name: '展厅',
		component: exhibitionHall
		}
		,
		{
		path: '/guide/exhibits',
		name: '展品',
		component: exhibits
		},
		{
		path: '/about/myGuide',
		name: '我的导览',
		component: myGuide
		}
	]
	})
	// 若是分享礼物，那么要授权（）

	// 在跳转前执行
	// router.beforeEach(({ meta, path, query }, from, next) => {
	// 第一次进页面授权
	// console.log('router index.js+++', sessionStorage.getItem('isUser'))
	// console.log('path', path)
router.beforeEach(({ meta, path, query, fullPath }, from, next) => {
	if (path) { _hmt.push(['_trackPageview', '/#' + fullPath]); }
	if (path.includes('/course_detail')) {
		query.course_id = path.split('/')[2]
		next({ path: '/lesson/purchaseLesson', query })
	}
	let isWechat = navigator.userAgent.match(/MicroMessenger/) !== null
	let urlCode = ''
	if (isWechat) {
		urlCode = util.getURLParameters(location.search).code;
	} else {
		urlCode = query.code
	}
	// let urlCode = util.getURLParameters(location.search).code;
	let user = localStorage.getItem('userInfo')
	// if (!urlCode && isWechat) {
	//     sessionStorage.setItem('isUser', true)
	//     let urlQuery = []
	//     for (let queryKey in query) {
	//       urlQuery.push(queryKey + '=' + query[queryKey])
	//     }
	//     if (this.$route.query.type !== 'redirect') {
	//       urlQuery.push('type=redirect')
	//     }
	//     // urlQuery.push('type=redirect')
	//     let redirectUrl = encodeURIComponent('http://guanboh5.jclang.me' + path + '?' + urlQuery.join('&'))
	//     location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9c3059e04210ad47&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
	// }
	// sessionStorage.setItem('isUser', true)
	if (!user) {
		if (urlCode) {
			let data = {
				code: urlCode,
				type: isWechat ? 1 : 2 // 1-微信公众号，2-微信外
			}
			sessionStorage.setItem('isUser', false)
			baseApiModules.wechatLogin(data).then(res => {
				if (res.code === 0) {
					if (res.data.phone === '') {
						localStorage.setItem('userInfo', JSON.stringify(res.data));
						// user.nick_name = res.data.nick_name;
						// user.avatar_url = res.data.avatar_url;
						// localStorage.setItem('userInfo', JSON.stringify(user));
						sessionStorage.setItem('isUser', false)
						// location.reload()
						setTimeout(() => {
							util.getHub().$emit('change')
							location.href = process.env.REDIRECT_URL + '/login/login';
						})
					} else {
						localStorage.setItem('userInfo', JSON.stringify(res.data));
						// user.nick_name = res.data.nick_name;
						// user.avatar_url = res.data.avatar_url;
						// localStorage.setItem('userInfo', JSON.stringify(user));
						sessionStorage.setItem('isUser', false)
						// location.reload()
						setTimeout(() => {
							util.getHub().$emit('change')
						})
					}
				} else if (!res || res.code === 1007) {
					if (isWechat) {
						sessionStorage.setItem('isUser', true)
						let urlQuery = []
						for (let queryKey in query) {
							urlQuery.push(queryKey + '=' + query[queryKey])
						}
						if (this.$route.query.type !== 'redirect') {
							urlQuery.push('type=redirect')
						}
						// urlQuery.push('type=redirect')
						let redirectUrl = encodeURIComponent(process.env.REDIRECT_URL + this.$route.path + '?' + urlQuery.join('&'))
						if (isWechat) {
							location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.WECHAT_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
						} else {
							location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${process.env.H5_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
						}
						// let redirectUrl = encodeURIComponent('http://guanboh5.jclang.me' + path + '?' + urlQuery.join('&'))
						// if (isWechat) {
						//   sessionStorage.setItem('isUser', true)
						//   // 测试
						//   // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9c3059e04210ad47&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
						//   // 正式
						//   location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc9a71045da247430&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
						// } else {
						//   // 测试
						//   // location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wx86573ee5545363f5&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
						//   // 正式
						//   location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wxa61bedc60f7f6cf4&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
						// }
					}
				}
			})
		}
		//  else {
		//   // if (isWechat) {
		//     // sessionStorage.setItem('isUser', true)
		//     let urlQuery = []
		//     for (let queryKey in query) {
		//       urlQuery.push(queryKey + '=' + query[queryKey])
		//     }
		//     if (this.$route.query.type !== 'redirect') {
		//       urlQuery.push('type=redirect')
		//     }
		//     // urlQuery.push('type=redirect')
		//     let redirectUrl = encodeURIComponent(process.env.REDIRECT_URL + this.$route.path + '?' + urlQuery.join('&'))
		//     console.log('code is null', isWechat, urlCode, redirectUrl)
		//     if (isWechat) {
		//       location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.WECHAT_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
		//     } else {
		//       location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${process.env.H5_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
		//     }
		//   // }
		// }
	}
	let shareImg = localStorage.getItem('shareImg')
	if (!shareImg) {
		baseApiModules.getShareImgUrl().then(res => {
			let shareImg = res.data.find(item => item.type === 6).value
			localStorage.setItem('shareImg', JSON.stringify(shareImg));
		}).catch(err => {
			this.$toast(err)
		})
	}
	baseApiModules.wxConfig().then(res => {
		if (!res.data) return;
		let urlQuery = []
		for (let queryKey in query) {
			urlQuery.push(queryKey + '=' + query[queryKey])
		}
		let newQuery = urlQuery.join('&')
		baseApiModules.getShareImgUrl().then(response => {
			let shareImg = response.data.find(item => item.type === 6).value
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: res.data.appId, // 必填，公众号的唯一标识
				timestamp: res.data.timestamp, // 必填，生成签名的时间戳
				nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
				signature: res.data.signature, // 必填，签名，见附录1
				jsApiList: [
				'onMenuShareTimeline',
				'onMenuShareAppMessage',
				'onMenuShareQQ',
				'onMenuShareWeibo',
				'onMenuShareQZone'
				] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			})
			wx.ready(() => {
				let shareContent = {
				title: '假日博物馆',
				desc: '一座移动的博物馆，没有围墙的博物馆，跟随名师，穿越时空，一眼千年，沿着东西方文明发展的脉络，从博物馆的视角，可以看见世界的各种可能性。愿我们的眼睛里，能容纳下不同维度的世界，有一个自由的灵魂，和一副见过世面的模样。',
				imgUrl: shareImg,
				// link: `http://${location.host}/?#${path}?${newQuery}`,
				link: `${process.env.REDIRECT_URL}${path}?${newQuery}`,
				// ${process.env.REDIRECT_URL}
					success: () => {
						this.shareSuccess()
					}
				}
				wx.onMenuShareTimeline(shareContent) // 分享到朋友圈
				wx.onMenuShareAppMessage(shareContent) // 分享给朋友
				wx.onMenuShareQQ(shareContent) // 分享到QQ
				wx.onMenuShareWeibo(shareContent) // 分享到腾讯微博
				wx.onMenuShareQZone(shareContent) // 分享到QQ空间
			})
		})
		// console.log(urlQuery.join('&'))
	}).catch(err => {
		this.$toast({
			message: err,
			className: 'toast-css'
		});
	})
	next()
})
router.afterEach(route => {
	// 设置页面标题
	document.title = '假日博物馆'
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js